import { render, staticRenderFns } from "./dragdrop_input.vue?vue&type=template&id=0cc0df62&scoped=true&"
import script from "./dragdrop_input.vue?vue&type=script&lang=js&"
export * from "./dragdrop_input.vue?vue&type=script&lang=js&"
import style0 from "./dragdrop_input.vue?vue&type=style&index=0&id=0cc0df62&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc0df62",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QBtn});
